var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smart-chart-card',{attrs:{"title":_vm.title,"is-loading":_vm.isLoading,"selectors":[_vm.areaGroupSelector, _vm.accountSelector, _vm.unitSelector],"charts":_vm.charts},on:{"set-period":_vm.getData}})}
var staticRenderFns = []

export { render, staticRenderFns }